import store from '@/store'
import { http } from '@/plugins/axios'
import { Notify } from 'vant'
import { testTel, isEmpty } from '@/tool/regular'

// 接口环境
const env = 'development'

// 配置接口环境对应域名 production为线上地址(必须) development为测试地址
const apisURL = {
    production: 'https://api.up-petroleum.com/api/v2/',
    development: 'https://apitest.up-petroleum.com/api/v2/',
}
// 生成接口baseUrl 生产环境强制为production
const baseURL = process.env.NODE_ENV == "production" ? apisURL['production'] : apisURL[env]
/**
 * 年会邀请
 */
function meetinginvitity({ name, phone, unit_name, inviter }) {
    return new Promise((resolve, reject) => {
        if (!testTel(phone)) {
            Notify({ type: 'warning', message: '电话号码格式不正确' })
            return
        }

        http({ method: 'post', url: 'addMeeting', data: { name, phone, unit_name, inviter }, myBaseUrl: baseURL }).then(res => {
            resolve(res)
        }).catch(err => {
            reject(err)
        })
    });
}

export {
    meetinginvitity,
}
